import * as React from 'react';
import styled, { StyledFunction, StyledComponentClass } from 'styled-components';
import { theme } from '../../theme/defaultTheme';
import { GridContextProps } from '../grid/GridContext';

const row: StyledFunction<GridContextProps> = styled.div;

/** @component */
export const StyledRowDiv = row`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: auto;
  margin-left: -${props => props.grid.columnGap / 2}px;
  margin-right: -${props => props.grid.columnGap / 2}px;
`;

StyledRowDiv.defaultProps = {
  theme
};
